/**
 * 管理者向け「確認専用モード」（機能フラグ crew_admin_monitor）の判定。
 *
 * 陸上管理者・システム管理者が船員アプリをスマホで開くと、
 * 打刻・履歴など入力項目を隠し「状況・アラート・連絡・設定」に絞った画面にする。
 * - 船員デモ（代理ログイン）中は船員としての操作なので従来画面のまま
 * - ポータルの会社は陸上用タブ（OFFICE_TABS）が優先されるのでここでは false
 */
import { hasFeature } from './featureFlags';
import { getImpersonation } from '../services/api';

export function isAdminMonitor(): boolean {
  if (!hasFeature('crew_admin_monitor')) return false;
  if (hasFeature('portal')) return false;
  if (getImpersonation()) return false;
  try {
    const u = JSON.parse(localStorage.getItem('catms_user') ?? '{}') as { user_role?: string };
    return ['shore_admin', 'system_admin'].includes(u?.user_role ?? '');
  } catch { return false; }
}
